import React, { useState, useEffect } from "react";
import { IonAvatar, IonText, IonIcon } from "@ionic/react";
import { User } from "../@types/user";
import api from "../utils/api";
import { warningOutline, checkmarkDoneOutline } from "ionicons/icons";
import userAvatar from '../assets/user.png';

const UserAvatarRoles: React.FC<{ user?: User, alert: number }> = ({ user = {}, alert }) => {
  const [avatarSrc, setAvatarSrc] = useState(userAvatar);

  useEffect(() => {
    const fetchAvatar = async () => {
      if (user?.profilePicture) {
        try {
          const token = localStorage.getItem('token');
          const profilePictureId = user?.profilePicture?.id || user?.profilePicture;
          const response = await fetch(`${api.baseURL}archive/${profilePictureId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setAvatarSrc(url);
          } else {
            console.error('Error fetching avatar:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchAvatar();
  }, [user]);

  return (
    <IonAvatar slot="start">
      <img
        src={avatarSrc}
        alt="User Avatar"
        width="100"
        height="100"
      />
      <p style={{position: "absolute", zIndex:'100', fontWeight:'bolder', left:'16px', bottom:'3px', fontSize: 17, margin: 0, maxWidth:100}}>
        {alert > 0 ? (
          <IonText color={"warning"} style={{display:'flex'}}>
            <IonIcon color={"warning"} icon={warningOutline} style={{fontSize:'19px'}}></IonIcon>
            <span style={{marginInlineStart:'8px'}}>{alert}</span>
          </IonText>
        ) : (
          <IonText color={"success"}>
            <IonIcon color={"success"} icon={checkmarkDoneOutline}></IonIcon>
          </IonText>
        )}
      </p>
    </IonAvatar>
  );
};

export default UserAvatarRoles;
